import { jsx as _jsx } from "react/jsx-runtime";
import { useState, createContext } from 'react';
export const MenuContext = createContext({});
export const MenuProvider = ({ children }) => {
    const [activeMenu, setActiveMenu] = useState('');
    const value = {
        activeMenu,
        setActiveMenu
    };
    return _jsx(MenuContext.Provider, { value: value, children: children });
};
